var countries = require('json!../../../../config/countries.json');
var editions = require('json!../../../../config/editions.json');

angular.module('signup', [
  'config',
  'services.utility',
  'security.service',
  'directives.serverError',
  'ui.bootstrap',
	'security',
	'services.localizedMessages'
]);

angular.module('signup').config(["$stateProvider", function ($stateProvider) {
  $stateProvider
    .state('signup', {
      url: '/signup',
      title: 'Sign Up',
      views: {
        header: {
          template: require('../common/header/header.tpl.html'),
          resolve: {
            user: ["User", "$q", "$timeout", "$state", function (User,$q, $timeout, $state) {
              return User.current(function (user) {
                if (user._id) {
                  $timeout(function() {
                    $state.go('account')
                  })
                  return $q.reject()
                }
                return user
              }).$promise;
            }],
          },
          controller: 'HeaderCtrl'
        },
        main: {
          template: require('./signup.tpl.html'),
          controller: 'SignupCtrl'
        },
        footer: {
          template: require('../common/footer/footer.tpl.html'),
          controller: 'FooterCtrl'
        }
      }
    });
}]);

angular.module('signup').controller('SignupCtrl',
  ["$scope", "$location", "$log", "utility", "security", "SOCIAL", "localizedMessages", function ($scope, $location, $log, utility, security, SOCIAL, localizedMessages) {
		$scope.localizedMessages = localizedMessages;
    // local variable
    var signupSuccess = function (data) {
      if (data.success) {
        //account/user created, redirect...
        var url = data.defaultReturnUrl || '/';
        return $location.path('/account/my-articles');
        return $location.path(url);
      }
      else {
        //error due to server side validation
        $location.$$search.mailSent = true;
        return $location.path('/login');
        $scope.errfor = data.errfor;
        angular.forEach(data.errfor, function (err, field) {
          $scope.signupForm[field].$setValidity('server', false);
        });
      }
    };
    var signupError = function (msg) {

      $scope.alerts.push({
        type: 'danger',
        msg: msg.data.message
      });
    };

    $scope.countries = [];
    _.forIn(countries, function (value, key) {
      $scope.countries.push({
        _id: key,
        name: value
      });
    });
    $scope.editions = [];
    _.forIn(editions, function (value, key) {
      $scope.editions.push({
        _id: key,
        name: value
      });
    });

    // model def
    $scope.user = {};
    $scope.alerts = [];
    $scope.errfor = {};
    $scope.social = angular.equals({}, SOCIAL) ? null : SOCIAL;

    // method def
    $scope.hasError = utility.hasError;
    $scope.showError = utility.showError;
    $scope.canSave = utility.canSave;
    $scope.closeAlert = function (ind) {
      $scope.alerts.splice(ind, 1);
    };
    $scope.submit = function () {
      const user = _.clone($scope.user);
      user.password = security.createHash(user.password);
      security.signup(user).then(signupSuccess, signupError);
    };
  }]);



// WEBPACK FOOTER //
// ./client/src/app/signup/signup.js